import axios from 'axios';

const getRegionCodeByCountry = (countryCode) => {
	// country code for country specific only.
	if (environment.region === 'sea') {
		switch (countryCode) {
			case 'VN':
				return 'vietnam';
		}
	}
	return environment.region;
};

const cdnApi = axios.create({
		baseURL: `//${process.env.VUE_APP_CDN_HOST}`,
	}),
	getFrontendConfig = (countryCode) =>
		cdnApi.get(`frontend/v2/${getRegionCodeByCountry(countryCode)}/config.json`).then((res) => res.data),
	getGameList = (countryCode) => cdnApi.get(`games/v2/${getRegionCodeByCountry(countryCode)}/gamelist.json`).then((res) => res.data);

export default {
	getFrontendConfig,
	getGameList,
};
